// Rename availability filter labels
(function() {
  var renaming = false;
  function renameFilterLabels() {
    if (renaming) return;
    renaming = true;
    document.querySelectorAll('.tag__text').forEach(function(el) {
      if (el.textContent.trim() === 'Niet op voorraad') {
        el.textContent = 'Tijdelijk uitverkocht';
      }
    });
    renaming = false;
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renameFilterLabels);
  } else {
    renameFilterLabels();
  }
  var timeout;
  var observer = new MutationObserver(function() {
    clearTimeout(timeout);
    timeout = setTimeout(renameFilterLabels, 200);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();